import Category_1 from './../assets/images/deutsches_schilddruesenzentrum_logo_nuklearmedizin.svg'
import Category_2 from './../assets/images/deutsches_schilddruesenzentrum_logo_radiojodtherapie.svg'
import Category_3 from './../assets/images/deutsches_schilddruesenzentrum_logo_chirurgie.svg'
import Category_8 from './../assets/images/deutsches_schilddruesenzentrum_logo_rehabilitation.svg'
import Category_9 from './../assets/images/deutsches_schilddruesenzentrum_logo_thermoablation.svg'
import Category_12 from './../assets/images/deutsches_schilddruesenzentrum_logo_endokrinologie.svg'
import Category_13 from './../assets/images/deutsches_schilddruesenzentrum_logo_hno.svg'
import {WEB_URL} from "../Const";

export function getIcon(slug) {

    switch (slug) {
        case 'nuklearmedizin':
            return Category_1;
        case 'radiojodtherapie':
            return Category_2;
        case 'chirurgie':
            return Category_3;
        case 'rehabilitation':
            return Category_8;
        case 'thermoablation':
            return Category_9;
        case 'endokrinologie':
            return Category_12;
        case 'hno':
            return Category_13;
        default:
    }

}

export function getMapIconColor(slug) {
    switch (slug) {
        case 'nuklearmedizin':
            return '#e0003a'
        case 'radiojodtherapie':
            return '#e0003a'
        case 'chirurgie':
            return '#e0003a'
        case 'rehabilitation':
            return '#e0003a'
        case 'thermoablation':
            return '#e0003a'
        case 'endokrinologie':
            return '#e0003a'
        case 'hno':
            return '#e0003a'
        default:
    }


}

export function getMapIcon(slug) {

    switch (slug) {
        case 'nuklearmedizin':
            return WEB_URL + 'wp-content/plugins/dsz-wordpress-list/map/src/assets/images/marker_deutsches_schilddruesenzentrum_logo_nuklearmedizin.png';
        case 'radiojodtherapie':
            return WEB_URL + 'wp-content/plugins/dsz-wordpress-list/map/src/assets/images/marker_deutsches_schilddruesenzentrum_logo_radiojodtherapie.png';
        case 'chirurgie':
            return WEB_URL + 'wp-content/plugins/dsz-wordpress-list/map/src/assets/images/marker_deutsches_schilddruesenzentrum_logo_chirurgie.png';
        case 'rehabilitation':
            return WEB_URL + 'wp-content/plugins/dsz-wordpress-list/map/src/assets/images/marker_deutsches_schilddruesenzentrum_logo_rehabilitation.png';
        case 'thermoablation':
            return WEB_URL + 'wp-content/plugins/dsz-wordpress-list/map/src/assets/images/marker_deutsches_schilddruesenzentrum_logo_thermoablation.png';
        case 'endokrinologie':
            return WEB_URL + 'wp-content/plugins/dsz-wordpress-list/map/src/assets/images/marker_deutsches_schilddruesenzentrum_logo_endokrinologie.png';
        case 'hno':
            return WEB_URL + 'wp-content/plugins/dsz-wordpress-list/map/src/assets/images/marker_deutsches_schilddruesenzentrum_logo_hno.png';
        default:
    }

}
